import { useTranslations } from 'next-intl'

export const EndDate: React.FC<{ time: string }> = ({ time }) => {
  const t = useTranslations()
  return (
    <>
      <span className='bg-navy bg-hourglass absolute top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full bg-center bg-no-repeat p-2 ltr:-left-6 rtl:-right-0'></span>
      <p className='rtl:-rtl-0 absolute top-7 mb-1 flex w-max -translate-x-1/2 flex-col items-start justify-center ltr:-left-0'>
        <span className='text-grey-50 font-medium'>{t('forms.freeTime')}</span>
        <span className='font-medium'>{time}</span>
      </p>
    </>
  )
}

export default EndDate
